export const getFullName = (data) => {
  const { first_name = "", last_name = "" } = data || {}
  return `${first_name} ${last_name}`.trim()
}
